module.exports = __webpack_public_path__ + "static/media/value-protect-logo-white.f99a1e37.png";